import React, { Component } from 'react';
import { Button, Input } from 'semantic-ui-react';
import { Commons } from 'components';

class STaffPosition extends Component {
  state = {  }
  render() {
    const { positionList, fn } = this.props;
    return (
      positionList
        ? positionList.data.rankposition.length === 0
          ? (
            <span key={0}>
              <Input
                className="modal-input"
                type="text"
                fluid
                placeholder="10자 이하로 입력해주세요."
                action
              >
                <input id="position-name" />
                <Button type="button" inverted color='black'>취소</Button>
                <Button type="button" color="green" onClick={fn.positionAdd}>완료</Button>
              </Input>
            </span>
          )
          : (
            positionList.data.rankposition.map((data, idx) => {

              let addInput = positionList.data.rankposition
              let inputbox = (
                <Input
                  className="modal-input"
                  type="text"
                  fluid
                  placeholder="10자 이하로 입력해주세요."
                  key={data.id}
                  action
                  defaultValue={data.name}
                >
                  <input id={data.id} />
                  <Button type="button" inverted color="green" onClick={(e) => fn.positionMod(data.id)}>수정</Button>
                  <Button type="button" inverted color="red" onClick={(e) => fn.positionDel(data.id)}>삭제</Button>
                </Input>
              );
              let list = null;

              if (addInput.length - 1 === idx) {

                list = (
                  <span key={0}>
                    {inputbox}
                    <Input
                      className="modal-input"
                      type="text"
                      fluid
                      placeholder="10자 이하로 입력해주세요."
                      action
                    >
                      <input id="position-name" />
                      <Button type="button" inverted color='black'>취소</Button>
                      <Button type="button" color="green" onClick={fn.positionAdd}>완료</Button>
                    </Input>
                  </span>
                );

              } else {
                list = inputbox
              }


              return list;

            })

          )

        : <Commons.LoadingBar />
    );
  }
}

export default STaffPosition;